<template>
  <div id="index">
    <!-- 书名、作者 -->
    <p class="bookname" v-show="isshow" :title="bookname">
      {{bookname}}
      <br />
      <span :title="author">{{author}}</span>
    </p>
    <!-- loading -->
    <div class="loadingBox" v-show="loadingbox">
      <div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p>本书共{{img_count}}页，请耐心等候</p>
    </div>
    <!--放大缩小-->
    <div class="bsmall" v-show="isshow">
      <img src="../../assets/picture/plus.png" class="bplus" @click="sizeClick(1)" title="放大图片" />
      <img src="../../assets/picture/reduce.png" class="breduce" @click="sizeClick(2)" title="缩小图片" />
    </div>
    <!--页面跳转-->
    <div class="page" v-show="isshow" title="当前页面">
      页面：
      <input type="text" v-model="page" class="page_now" @keyup.enter="pushup" />&nbsp;&nbsp;of&nbsp;&nbsp;
      <span class="page_count">{{img_count}}</span>
    </div>
    <!--左右翻页-->
    <img
      src="../../assets/picture/xiangzuo.png"
      v-show="isshow"
      class="left_btn"
      @click="upclick(1)"
      title="上一页"
    />
    <img
      src="../../assets/picture/xiangzuo1.png"
      v-show="isshow"
      class="right_btn"
      @click="upclick(2)"
      title="下一页"
    />
    <!--目录-->
    <div v-if="!isUndivided" class="undivided" v-show="isshow">
      <div class="catalog" v-show="isCatalog">
        <p class="cat_title">目录</p>
        <div class="cat_close" @click="isCatalog = !isCatalog"></div>
        <ul class="cat_ul">
          <li
            v-for="(item, index) in catalogArr"
            class="cat_li"
            :class="{cat_active: subsectionid == index}"
            @click="catalog(index,item)"
            v-bind:key="index"
          >
            <div class="cat_dot"></div>
            <p class="cat_p">
              {{item.roll_name}}
              <span>/</span>
              {{pinyinArr[index]}}
            </p>
          </li>
        </ul>
      </div>
      <div class="catalog_hide" v-show="!isCatalog" @click="isCatalog = !isCatalog" title="图片目录">目录</div>
    </div>
    <!-- 右下角标注按钮 -->
    <ul class="iconbox" v-show="isshow" v-if="!iswhite">
      <li @click="isshowmytags = !isshowmytags" title="我的标注">
        <img src="../../assets/picture/list_icon@2x.png" alt />
        <p>我的标注</p>
      </li>
      <li @click="srceen" id="screen" title="新建标注">
        <img src="../../assets/picture/NEW_icon@2x.png" alt />
        <p>新建标注</p>
      </li>
      <li @click="isshowmymarks = !isshowmymarks" title="我的书签">
        <img src="../../assets/picture/bookmarks_icon@2x.png" alt />
        <p>我的书签</p>
      </li>
    </ul>
    <!--图片展示区-->
    <div v-for="(item,index) in imgArr " class="imgbox" id="imgbox" ref="ccc" v-bind:key="index">
      <!-- <img :src="item.url"> -->
      <div class="imgli" id="imgli" ref="aaa">
        <!-- 书签添加删除部分 -->
        <div class="bookmark" v-show="isshow" v-if="!iswhite">
          <button
            class="baddmark"
            @click="addmark(2,item,index)"
            :disabled="ispushmark"
            v-show="!item.be_marked"
          ></button>
          <button
            class="bdeletemark"
            @click="removemark(item,index)"
            :disabled="ispushmark"
            v-show="item.be_marked"
          ></button>
          <!-- ../../assets/picture/bookmarks_icon_nor@2x.png -->
          <!-- <img
            src="../../assets/picture/bookmarks_icon_pre@2x.png" 
            @click="removemark(item,index)"
            v-show="item.be_marked"
          />-->
        </div>
        <div class="marktitle" v-if="!iswhite">
          <p v-show="!item.be_marked">添加标签</p>
          <p v-show="item.be_marked">删除标签</p>
        </div>
      </div>
      <div
        :class="[pagetagsArr[index].tagsarr.length==0?'page_tag2':'','page_tag']"
        ref="bbb"
        v-show="ispicturetags&&isshow"
        v-if="!iswhite"
      >
        <div class="inpagetag">
          <div class="pt_li" v-for="(titem,tindex) in pagetagsArr[index].tagsarr" :key="tindex">
            <span class="pt_disc"></span>
            <div class="ptli_content">
              <!-- <div
                class="ptli_img"
                @click="open_img(titem)"
                :style=" {backgroundImage:'url('+titem.url+')'}"
              ></div>-->
              <div class="ptli_img">
                <viewer>
                  <img :src="titem.url" alt />
                </viewer>
              </div>
              <p class="ptli_text">{{titem.content}}</p>
              <p class="ptli_user">
                <!-- <img :src="titem.head_img" alt="">
                {{titem.username}} -->
                <span class="ptli_time">{{titem.add_time}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="pagetag_morebox" v-show="tagmoreArr[index]">
          <div class="pagetag_more" @click="pagetagmore(item.url,pagetagsArr[index],index)">更多</div>
        </div>
      </div>
    </div>
    <!-- 心得 -->
    <div class="commentbox" v-show="isshow">
      <div class="comments_box" ref='ddd'>
      <div class="comments_title">
            留下您的心得
            <span></span>
          </div>
        <el-input
          v-if="!iswhite"
          type="textarea"
          :autosize="{ minRows: 3}"
          style="heigth:200px;"
          placeholder="说说你的心得"
          v-model="comment"
        ></el-input>
        <button class="comment_confirm" v-if="!iswhite" @click="addComments()">发表心得</button>
        <div class="comments">
          <div class="title">全部心得</div>
          <div class="comment" v-for="(item,index) in comments" v-bind:key="index">
            <div class="comment_title">
              <strong class="user">{{item.name}}</strong>
              <span class="date">{{item.publish_time}}</span>
            </div>
            <pre v-text="item.content" class="comment_content"></pre>
          </div>
          <div v-if="is_all" class="no_more">没有更多了</div>
          <div v-else class="more_info" @click="LoadMore">
            <div v-if="isLoading">
              <img src="../../assets/public/ancientBooks/loading.gif" alt="加载" />
            </div>
            <div v-else>查看更多</div>
          </div>
        </div>
      </div>
      <div class="commentnot" v-show="ispicturetags"></div>
    </div>
    <!-- 历史阅读跳转弹窗 -->
    <div class="dialog" v-show="dialogVisible" v-if="!iswhite">
      <div class="dialog_center">
        <p class="dialogtitle">上次已阅读到第{{historypage}}页</p>
        <div class="dialogconfirm">
          <p class="dialogfalse" @click="resetread">重头阅读</p>
          <p class="dialogtrue" @click="historyup">继续阅读</p>
          <!-- <p class="dialogfalse" >重头阅读</p>
          <p class="dialogtrue" >继续阅读</p>-->
        </div>
      </div>
    </div>
    <!-- 添加标注弹窗 -->
    <!-- <div id="screen" class="screen" @click="srceen" v-show="isshow" title="截图加注释">截图</div> -->
    <div class="tagsbox" v-show="istagsshow" v-if="!iswhite">
      <!-- 关闭按钮 -->
      <p class="closetagbox" @click="closetagbox" alt></p>
      <!-- 截图区域 -->
      <div class="tagsimgshow" v-show="!isnewsrceen">
        <img :src="screenimg" class="tagsimg" />
      </div>
      <!-- 关闭按钮 -->
      <p class="resetscreen" @click="closescreen" v-show="!isnewsrceen"></p>
      <!-- 重新截图 -->
      <div class="addscreen" v-show="isnewsrceen" @click="srceen"></div>
      <textarea
        name
        id="tagsarea"
        cols="33"
        rows="5"
        class="tagsarea"
        placeholder="研究表明，哪怕每次只输入一个符号，也能大幅提高学习效果。"
        @keyup.enter="tagssubmit"
      ></textarea>
      <div class="tag_bottom">
         <p class="share_community">
          <img
            src="../../assets/picture/tick_icon_nor@2x.png"
            v-show="!issharecommunity"
            @click="issharecommunity=!issharecommunity"
            alt
            srcset
          />
          <img
            src="../../assets/picture/tick_icon_pre@2x.png"
            v-show="issharecommunity"
            @click="issharecommunity=!issharecommunity"
            alt
            srcset
          />
          <span @click="issharecommunity=!issharecommunity">同步到社区</span>
        </p>

        <button class="tagssubmit" @click="tagssubmit" :disabled="ispushbtn">完成</button>
      </div>
    </div>
    <!-- 我的注释部分 -->
    <div class="mytags" v-show="isshowmytags" v-if="!iswhite">
      <div class="mytags_center">
        <div class="closebox" @click="isshowmytags = !isshowmytags" v-show="!openimg"></div>
        <div
          class="time_line infinite-list"
          v-show="istagsArr"
          ref="scrollList"
          v-infinite-scroll="loadingmytags"
          infinite-scroll-disabled="istagsall"
          infinite-scroll-distance="10"
          infinite-scroll-immediate="false"
        >
          <div
            :class="[index%2==0?'right':'left','list','infinite-list-item']"
            v-for="(item,index) in mytagsArr"
            :key="index"
          >
            <!-- {{item.content}} -->
            <span class="tags_circle">
              <viewer>
                <img :src="item.url" alt />
              </viewer>
              <!-- <span @click="open_img(item)">查看原图</span> -->
            </span>
            <span class="tags_text" @click="upgopage(item.img_id,1)">
              <span class="tags_page">{{item.add_time}}</span>
              <span class="centent">{{item.content}}</span>
            </span>
          </div>
        </div>
        <div v-if="istagsall" class="no_more">没有更多了</div>
        <div v-show="!istagsArr" class="notmarks">
          <img src="../../assets/picture/tags.png" alt />
          <p>还没有标注，现在就去添加吧~</p>
        </div>
      </div>
    </div>
    <div class="img_open" v-show="openimg">
      <img :src="openimg_img" class="openimg_img" ondragstart="return false;" />
      <div class="closeimg" @click="openimg = !openimg"></div>
    </div>
    <!-- 我的书签部分 -->
    <div class="mymarks" v-show="isshowmymarks" v-if="!iswhite">
      <div class="mymarks_center">
        <div class="closebox" @click="isshowmymarks = !isshowmymarks"></div>
        <div
          class="time_line infinite-list"
          v-show="ismarkArr"
          ref="scrollList"
          v-infinite-scroll="loadingmymark"
          infinite-scroll-disabled="ismarksall"
          infinite-scroll-distance="10"
          infinite-scroll-immediate="false"
        >
          <div
            :class="[index%2==0?'right':'left','list','infinite-list-item']"
            v-for="(item,index) in mymarksArr"
            :key="index"
          >
            <span class="img_circle">
              <viewer>
                <img :src="item.url" alt />
              </viewer>
            </span>
            <span class="text" @click="upgopage(item.page,2)">
              <span class="mark_page">
                第
                <span class="font_74">{{item.page}}</span>页
              </span>
              <span class="time">{{item.add_time}}</span>
            </span>
          </div>
        </div>
        <div v-if="ismarksall" class="no_more">没有更多了</div>
        <div v-show="!ismarkArr" class="notmarks">
          <img src="../../assets/picture/marks.png" alt />
          <p>还没有书签，现在就去添加吧~</p>
        </div>
      </div>
    </div>
    <!-- 更多标注对照部分 -->
    <div class="tags_more" v-show="istagmore">
      <div class="closeimg" @click="istagmore = !istagmore"></div>
      <img :src="tagsmoreArr.url" class="pagetagimg" alt />
      <div class="tags_right page_tag">
        <div class="pt_li" v-for="(item,index) in tagsmoreArr.tags" :key="index">
          <span class="pt_disc"></span>
          <div class="ptli_content">
            <!-- <div
              class="ptli_img"
              :style=" {backgroundImage:'url('+item.url+')'}"
              @click="open_img(item)"
            ></div>-->
            <div class="ptli_img">
              <viewer>
                <img :src="item.url" alt />
              </viewer>
            </div>
            <p class="ptli_text">{{item.content}}</p>
            <p class="ptli_user">
              <!-- <img src="../../assets/community/headimg/User_icon_1.png" alt="">
              超级无敌机智花-->
              <span class="ptli_time">{{item.add_time}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="position: fixed;top: 20px;right: 20px;z-index:999;">
			<img :src="screenimg" alt="">
    </div>-->
  </div>
</template>
<script>
import { addstamp } from "../../util/stamp";
import { chineseToPinYin } from "../../util/vue-py.js";
// import domtoimage from 'dom-to-image';
// import kscreenshot from "kscreenshot";
import { setTimeout, setInterval, clearInterval } from "timers";
import { stat } from "fs";
export default {
  data() {
    return {
      imgArr: [],
      img_count: 0,
      imgheigth: 100,
      lastItem: 0,
      currentimg: 1,
      userid: "",
      volumeid: "",
      bookname: "",
      author: "",
      page: 1,
      catalogArr: [],
      pinyinArr: [],
      booknoArr: [],
      subsectionid: 0,
      isCatalog: true,
      isUndivided: false,
      isok: true,
      // 截图方法
      screenkey: null,
      // 截后base64码图片
      screenimg: "",
      // 注释弹窗
      isscreenpop: false,
      // 截图前后位置定点
      srcolltop: null,
      // 截图时其他控件是否显示
      isshow: true,
      // dialog是否弹出
      dialogVisible: false,
      // 历史页码
      historypage: null,
      // 是否从书签页跳转过来的
      ismarkspagejump: false,
      // 是否重新截图
      isnewsrceen: false,
      // 注释弹窗
      istagsshow: false,
      // 是否显示我的标注窗口
      isshowmytags: false,
      // 是否显示我的标注窗口
      isshowmymarks: false,
      mymarksArr: [],
      mytagsArr: [],
      marks_current_page: 1,
      marks_total_pages: null,
      ismarksall: false,
      per_page: 10,
      tags_current_page: 1,
      tags_total_pages: null,
      istagsall: false,
      openimg: false,
      openimg_img: "",
      ismarkArr: false,
      istagsArr: false,
      ispushbtn: false,
      isIos: false,
      // 是否分享到社区
      issharecommunity: false,
      // 标注是否公开
      ispublic:false,
      //   是否有标注
      ispicturetags: false,
      pagetagsArr: [],
      tagsmoreArr: [],
      tagimgheigth: 0,
      istagmore: false,
      iswhite: null,
      tagmoreArr: [],
      fullscreenLoading: false,
      ispushmark: false,
      //存放图片宽高比例
      directArr: [],
      loadingbox: true,
      comments: [], //评论
      comments_current_page: 1, //评论当前页
      comments_page_size: 8, //评论每页个数
      comments_total_pages: null, //评论总页数
      is_all:false,
      comment:'',
      isLoading: false,
      detail_id:null,
      canscreen:true
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      { name: "keywords", content: "智能阅读,中医,古籍" },
      {
        name: "description",
        content:
          "在线智能阅读千年医典数据库的热门中医古籍,可添加书签,评论,标注,以便与其他用户交流沟通"
      }
    ]
  },
  created() {
    var isiel = this.isIE()
    if(isiel){
      this.canscreen = false
    }else{
      this.canscreen = true
    }
    this.iswhite = this.$store.state.iswhitelist;
    this.volumeid = parseInt(this.$route.query.volume_id);
    if(this.$route.query.detail_id){
      this.detail_id = this.$route.query.detail_id
    }
    this.img_count = parseInt(this.$route.query.ct) || 0;
    if (!this.iswhite) {
      this.userid = parseInt(this.$store.state.user_id);
      // console.log(this.userid);
      this.loadingmymark();
      this.loadingmytags();
      this.getComments();
    }
    this.loadimg();
    var that = this;
    //监听键盘事件，键盘左右键上下翻页
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (!that.istagsshow) {
        if (key == 37) {
          //左箭头
          that.upclick(1);
        } else if (key == 39) {
          //右箭头
          that.upclick(2);
        }
      }
    };
    document.oncontextmenu = function() {
      return false;
    };
    //65指键盘中的A
    this.screenkey = new kscreenshot({
      key: 65,
      cancelCB() {
        var domarr = document.getElementsByClassName("imgbox");
        for (var i = 0; i < that.imgArr.length; i++) {
          domarr[i].classList.remove("hidden");
          // console.log("bbbb")
        }
        that.isshow = true;
        setTimeout(function() {
          window.scrollTo(100, that.scrollTop);
        }, 500);
        // console.log("取消后")
      },
      endCB(a) {
        that.istagsshow = true;
        var domarr = document.getElementsByClassName("imgbox");
        for (var i = 0; i < that.imgArr.length; i++) {
          domarr[i].classList.remove("hidden");
          // console.log("aaaa")
        }
        // that.istagsshow = true
        that.isshow = true;
        setTimeout(function() {
          window.scrollTo(100, that.scrollTop);
          that.screenimg = a;
        }, 500);
      }
    });
  },
  mounted() {
    var that = this;
    window.addEventListener("scroll", function(e) {
      that.sendAsk();
    });

    var pathpage = parseInt(this.$route.query.page);
    // console.log(pathpage)
    if (pathpage) {
      this.ismarkspagejump = true;
      this.page = pathpage;
      // this.pushup()
      setTimeout(function() {
        that.pushup();
      }, 1000);
    }
    this.OSnow();
    // window.onresize = () => {
    // 	console.log(devicePixelRatio)
    // 	var a = that.detectZoom()
    // 	console.log(a)
    // }
  },
  methods: {
    isIE() {
    if(!!window.ActiveXObject || "ActiveXObject" in window){
      return true;
    }else{
      return false;
　　 }
},
    check_share(isshare){
      console.log(11111)
      if(isshare){
        this.issharecommunity = true
        // this.ispublic = true
      }else{
        this.issharecommunity = false
        // this.ispublic = false
      }
      // console.log(this.issharecommunity)
      // console.log(this.ispublic)
    },
    upgopage(data, num) {
      var that = this;
      //   console.log(data)
      // this.page =
      if (num == 1) {
        for (var j = 0; j < this.imgArr.length; j++) {
          if (data == this.imgArr[j].id) {
            this.page = j + 1;
            this.isshowmytags = false;
            setTimeout(function() {
              that.pushup();
            }, 1000);
            this.loadpagetags(this.page - 1, 1);
          }
        }
      } else if (num == 2) {
        this.page = data;
        this.isshowmymarks = false;
        this.pushup();
      }
    },
    closetagbox() {
      $("#tagsarea").val("");
      this.istagsshow = !this.istagsshow;
    },
    closescreen() {
      this.screenimg = "";
      this.isnewsrceen = !this.isnewsrceen;
    },
    resetread() {
      this.dialogVisible = false;
      var ind = this.page - 1;
      var item = this.imgArr[ind];
      if (typeof item != "undefined") {
        this.addmark(1, item, ind);
      }
    },
    // 返回屏幕缩放比例
    detectZoom() {
      var ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }

      if (ratio) {
        ratio = Math.round(ratio * 100);
      }

      return ratio;
    },
    load() {
      var that = this;
      var crossOrigin = "anonymous";
      // var imgdiv = $('div#index').find("div.imgbox").find("div#imgli")
      var todiv = document.getElementsByClassName("imgli");
      // console.log(todiv)
      // todiv[0].appendChild(images)
      for (var i = 0; i < todiv.length; i++) {
        var images = document.createElement("img");
        images.src = that.imgArr[i].url;
        // images.class = "img2"
        images.setAttribute(
          "style",
          "width: 100%;display:block;margin:0 auto;"
        );
        images.setAttribute("ondragstart", "return false");
        images.setAttribute("class", "imgcenter");
        // ondragstart="return false"

        if (that.imgArr[i].url.substr(0, 5) !== "data:") {
          images.crossOrigin = crossOrigin;
        }
        todiv[i].appendChild(images);
        // var div = document.createElement('div');
        // div.setAttribute("style", "width: 256px;height: 100%;border:1px solid red;display:inline-block;");
        // todiv[i].appendChild(div)
      }
      if (that.$route.query.imd) {
        for (var j = 0; j < that.imgArr.length; j++) {
          if (that.$route.query.imd == that.imgArr[j].id&&that.ispicturetags) {
            that.page = j + 1;
            setTimeout(function() {
              that.pushup();
            }, 1000);
            that.loadpagetags(that.page - 1, 1);
          }
        }
      }
      that.loadingimgsize();
    },
    //修改标注对照框大小
    loadingimgsize2(i) {
      var that = this;
      // var width = this.$refs.aaa[0].offsetWidth
      // var img = this.imgArr[0].url
      // this.getImageWidth(img,function(w,h){
      //   var bl = h/w
      //   var hei = bl*width
      //   console.log(hei)
      //   that.settagbox(hei)
      //  });
      let img = this.imgArr[i].url;
      let bl = null;
      let width = this.$refs.aaa[i].offsetWidth;
      this.getImageWidth(img, function(w, h) {
        bl = h / w;
        that.directArr.push(bl);
        var hei = bl * width;
        that.$refs.bbb[i].style.height = hei + "px";
        that.settagmore(i, 2);
      });
    },
    setimgsize2(number) {
      var that = this;
      // var width = this.$refs.aaa[0].offsetWidth
      // var img = this.imgArr[0].url
      // this.getImageWidth(img,function(w,h){
      //   var bl = h/w
      //   var hei = bl*width
      //   console.log(hei)
      //   that.settagbox(hei)
      //  });
      for (let i = 0; i < this.imgArr.length; i++) {
        let num = i;
        let bl = this.directArr[num];
        let width = null;
        if (number == 1) {
          width = this.$refs.aaa[i].offsetWidth + 50;
        } else {
          width = this.$refs.aaa[i].offsetWidth - 50;
        }
        if (width < 400) {
          width = this.$refs.aaa[i].offsetWidth;
        } else if (width > 1000) {
          width = this.$refs.aaa[i].offsetWidth;
        }
        var hei = bl * width;
        that.$refs.bbb[num].style.height = hei + "px";
        that.settagmore(num, 2);
      }
    },
    getImageWidth(url, callback) {
      var img = new Image();
      img.src = url;
      // var that = this
      // 如果图片被缓存，则直接返回缓存数据
      if (img.complete) {
        callback(img.width, img.height);
      } else {
        // 完全加载完毕的事件
        img.onload = function() {
          callback(img.width, img.height);
        };
      }
    },
    //加载时更新图片大小
    loadingimgsize() {
      var a = document.body.offsetHeight;
      this.tagimgheigth = a;
      var b = a / 1.4;
      for (var i = 0; i < this.imgArr.length; i++) {
        this.$refs.ccc[i].style.minHeight = a + "px";
        // console.log(this.$refs.aaa[i].img)
        // this.$refs.aaa[i].style.height = a + "px";
        // this.$refs.bbb[i].style.height = a + "px";
        this.$refs.aaa[i].style.width = b + "px";
        if(this.ispicturetags){
          this.loadingimgsize2(i);
        }
        if (i == this.imgArr.length - 1) {
          this.$refs.ddd.style.width = b+"px";
          this.loadingbox = false;
          if (!this.ismarkspagejump && !this.$route.query.imd) {
            this.loadinghistory();
          }
        }
      }
      if(this.ispicturetags){
        this.loadpagetags(0, 3);
        this.loadpagetags(1, 3);
        this.loadpagetags(2, 3);
      }
    },
    //图片缩放
    sizeClick(num) {
      let that = this;
      for (var i = 0; i < this.imgArr.length; i++) {
        var a = null;
        if (num == 1) {
          // var a = this.$refs.aaa[i].offsetHeight + 100;
          a = this.$refs.aaa[i].offsetWidth + 50;
        } else if (num == 2) {
          a = this.$refs.aaa[i].offsetWidth - 50;
          // var a = this.$refs.aaa[i].offsetHeight - 100;
        }
        // 最大最小高
        // if (a < 600) {
        //   a = 600;
        // } else if (a > 2500) {
        //   a = 2500;
        // }
        // 最大最小宽
        if (a < 400) {
          a = this.$refs.aaa[i].offsetWidth;
        } else if (a > 1000) {
          a = this.$refs.aaa[i].offsetWidth;
        }
        if(i == this.imgArr.length-1){
          this.$refs.ddd.style.width = a+"px";
        }
        this.$refs.aaa[i].style.width = a + "px";
        // var b = a / 1.4;
        // this.$refs.aaa[i].style.height = a + "px";
        // this.$refs.bbb[i].style.height = a + "px";
        // this.settagmore(i, 1);
      }
      that.setimgsize2(num);
    },
    // 添加标注
    tagssubmit() {
      var that = this;
      var area = $("#tagsarea").val();
      if (area != "" && that.screenimg != "") {
        this.ispushbtn = true;
        var imgid = that.imgArr[that.page - 1].id;
        var params = {
          user_id: that.userid,
          volume_id: that.volumeid,
          img: that.screenimg,
          content: area,
          img_id: imgid,
          is_share: this.issharecommunity
        };
          // is_public:this.ispublic
        var sign = addstamp(params);
        delete params.token;
        params["sign"] = sign;
        that.$axios
          .post("tags", params)
          .then(function(res) {
            // console.log(res)
            if (res.data.status_code == 200) {
              that.ispushbtn = false;
              that.istagsshow = false;
              that.$message({
                message: "成功添加标注！",
                type: "success"
              });
              that.loadingmytags();
              that.loadpagetags(that.page - 1, 2);
              // that.loadpagetags(that.page);
              // that.loadpagetags(that.page+1);
              $("#tagsarea").val("");
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        alert("请添加标注或截图");
      }
    },
    // 截图
    srceen() {
      var that = this;
      if(this.canscreen){
        var Percentage = this.detectZoom();
        // console.log(devicePixelRatio)
        // 正常尺寸不
        if (Percentage == 100) {
          this.openFullScreen();
        } else if (this.isIos && Percentage == 200) {
          this.openFullScreen();
        } else {
          alert("浏览器滚轮放大缩小，无法使用截图功能");
          // $("#screen").classList.add("prohibit")
        }
      }else{
        alert("ie浏览器暂时无法添加标注，请更换chrome浏览器后再使用！");
      }
    },
    openFullScreen() {
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "正在加载中...",
        spinner: "my-el-custom-spinner",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
        this.isnewsrceen = false;
        this.isshow = false;
        this.istagsshow = false;
        this.dialogVisible = false;
        var page = parseInt(this.page);

        this.scrollTop = $(window).scrollTop();
        var domarr = document.getElementsByClassName("imgbox");
        if (page < 3) {
          for (var i = 6; i < this.imgArr.length; i++) {
            domarr[i].classList.add("hidden");
          }
        } else if (page > 3) {
          for (var i = 0; i < this.imgArr.length; i++) {
            if (i < page - 3 || i > page + 3) {
              domarr[i].classList.add("hidden");
            }
          }
        } else if (this.imgArr.length - page < 3) {
          for (var i = 0; i < this.imgArr.length - 6; i++) {
            domarr[i].classList.add("hidden");
          }
        }
        setTimeout(function() {
          that.isshow = true;
        }, 2000);
        setTimeout(() => {
          that.screenkey.startScreenShot();
        }, 500);
      }, 4000);
    },
    // 截图func
    screenfunc() {
      var that = this;
      // var page = parseInt(this.page);
      // this.scrollTop = $(window).scrollTop();
      // // console.log(this.scrollTop)
      // var domarr = document.getElementsByClassName("imgbox");
      // if (page < 3) {
      //   for (var i = 6; i < this.imgArr.length; i++) {
      //     // this.$refs.imgbox[i].style.display = 'none'
      //     domarr[i].classList.add("hidden");
      //   }
      // } else if (page > 3) {
      //   for (var i = 0; i < this.imgArr.length; i++) {
      //     if (i < page - 3 || i > page + 3) {
      //       // this.$refs.imgbox[i].style.display = 'none'
      //       domarr[i].classList.add("hidden");
      //     }
      //   }
      // } else if (this.imgArr.length - page < 3) {
      //   for (var i = 0; i < this.imgArr.length - 6; i++) {
      //     // this.$refs.imgbox[i].style.display = 'none'
      //     domarr[i].classList.add("hidden");
      //   }
      // }
      that.screenkey.startScreenShot();
      setTimeout(function() {
        that.isshow = true;
      }, 2000);
    },
    // 查看原图
    open_img(item) {
      //   console.log(item);
      this.openimg = !this.openimg;
      this.openimg_img = item.url;
    },
    //上下页面跳转
    upclick(num) {
      var c = this.sendAsk();
      var b = [];
      var lis = $("div#index").find("div.imgbox");
      $.each(lis, function(index, item) {
        var mTop = item.offsetTop;
        b.push(mTop);
      });
      if (num == 1) {
        c = c - 2;
      } else {
        if (c == b.length) c = c - 1;
      }
      window.scrollTo(100, b[c]);
    },
    sendAsk() {
      var that = this;
      var lis = $("div#index").find("div.imgbox");
      var swHeight = $(window).scrollTop() + $(window).height();
      var a = 0;
      $.each(lis, function(index, item) {
        var mTop = item.offsetTop;
        var dItem = index + 1;

        if (mTop < swHeight) {
          a++;
          //						console.log(index + 1 + "个发送请求  ");
          that.lastItem += 1;
          that.currentimg += 1;
        }
      });
      if (a != this.currentimg) {
        //					console.log(a + "个发送请求  ");
        that.page = a;
      }
      this.currentimg = a;
      return a;
    },
    //初始加载图片
    loadimg() {
      var that = this;
      if (this.iswhite) {
        var params = {
          ip: this.$store.state.ip
        };
        if(this.detail_id){
          params.detail_id = this.detail_id
        }
        // console.log(params.ip)
      } else {
        var params = {
          user_id: this.userid,
          volume_id: this.volumeid
        };
        if(this.detail_id){
          params.detail_id = this.detail_id
        }
        var sign = addstamp(params);
        delete params.token;
        params["sign"] = sign;
      }
      this.$axios
        .get("/book/read/" + this.volumeid, {
          params
        })
        .then(function(res) {
          // console.log(res.data);
          that.imgArr = res.data.data.images;
          that.bookname = res.data.data.book_info.name;
          that.author = res.data.data.book_info.author;
          that.img_count = that.imgArr.length;
          that.loadingcatalog();
          // var ind = that.page-1
          // var item = that.imgArr[ind]
          // if(typeof item != 'undefined'){
          // 	that.addmark(1,item,ind)
          // }
          for (var i = 0; i < that.imgArr.length; i++) {
            that.pagetagsArr.push({
              current_page: 1,
              total_pages: 1,
              tagsarr: []
            });
            that.tagmoreArr.push(false);
          }
          setTimeout(function() {
            that.load();
            // that.loadingimgsize();
          }, 500);
        });
    },
    // 初始加载目录
    loadingcatalog() {
      var that = this;
      let params = {}
      if(this.detail_id){
          params.detail_id = this.detail_id
        }
      this.$axios.get("/book/catalog/" + this.volumeid,{params}).then(function(res) {
        if (res.data.data[0].roll_name == "不分卷") {
          that.isUndivided = true;
        } else {
          that.isUndivided = false;
          that.catalogArr = res.data.data;
          for (var i = 0; i < that.catalogArr.length; i++) {
            var a = chineseToPinYin(that.catalogArr[i].roll_name);
            that.pinyinArr.push(a);
          }
          // console.log(that.imgArr)
          // console.log(that.catalogArr)
          for (var c = 0; c < that.catalogArr.length; c++) {
            for (var j = 0; j < that.imgArr.length; j++) {
              if (that.imgArr[j].no == that.catalogArr[c].book_img_no) {
                // console.log(j+'----'+c)
                var b = j + 1;
                that.booknoArr.push(b);
                continue;
              }
            }
          }
          // console.log(that.booknoArr)
        }
      });
    },
    // 加载历史阅读页
    loadinghistory() {
      var that = this;
      // console.log(this.userid)
      var params = {
        user_id: this.userid,
        volume_id: this.volumeid
      };
      if(this.detail_id){
          params.detail_id = this.detail_id
        }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      this.$axios
        .get("book/mark/" + this.volumeid, { params })
        .then(function(res) {
          // console.log(res.data)
          if (res.data.status_code == 200) {
            that.historypage = res.data.data.page;
            if (that.historypage != 1) {
              that.dialogVisible = true;
            }
          } else if (res.data.status_code == 4001) {
            // console.log("is first")
            var ind = that.page - 1;
            var item = that.imgArr[ind];
            if (typeof item != "undefined") {
              that.addmark(1, item, ind);
            }
          }
        });
    },
    // 加载书签
    loadingmymark() {
      // console.log('----------loadingmymark----------'+this.marks_current_page)
      var that = this;
      var params = {
        user_id: this.userid,
        volume_id: this.volumeid,
        page: this.marks_current_page,
        page_size: this.per_page
      };
      if(this.detail_id){
          params.detail_id = this.detail_id
        }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      that.$axios.get("marks", { params }).then(function(res) {
        // console.log(res)
        // that.mymarksArr = res.data.data.book_marks
        if (res.data.status_code == 200) {
          if (typeof res.data.data != "number") {
            that.marks_total_pages = res.data.data.total_pages;
            that.marks_current_page = res.data.data.current_page;
            that.isLoading = false;
            that.ismarkArr = true;
            // this.isKaiGuan = true
            if (that.marks_current_page == that.marks_total_pages) {
              that.ismarksall = true;
              // this.isKaiGuan = false
            }
            if (that.marks_current_page == 1) {
              that.mymarksArr = res.data.data.book_marks;
            } else {
              that.mymarksArr = that.mymarksArr.concat(
                res.data.data.book_marks
              );
            }
          } else {
            that.ismarkArr = false;
          }
          // that.book_info = res.data.data.book_info
        }
      });
    },
    // 加载标注
    loadingmytags() {
      // console.log('----------loadingmytags----------'+this.tags_current_page)
      var that = this;
      var params = {
        user_id: this.userid,
        volume_id: this.volumeid,
        page: this.tags_current_page,
        page_size: this.per_page
      };
      if(this.detail_id){
          params.detail_id = this.detail_id
        }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      that.$axios.get("tags", { params }).then(function(res) {
        // that.mytagsArr = res.data.data.book_tags;
        // console.log(that.mytagsArr)
        that.mytagsArr = res.data.data.book_tags;
        that.tags_total_pages = res.data.data.total_pages;
        that.tags_current_page = res.data.data.current_page;
        // console.log(res.data.data.book_tags);
        if (res.data.data.book_tags.length != 0) {
          that.ispicturetags = true;
        }
        if (res.data.status_code == 200) {
          if (typeof res.data.data != "number") {
            that.isLoading = false;
            // that.istagsArr = true
            // this.isKaiGuan = true
            if (that.tags_current_page == that.tags_total_pages) {
              that.istagsall = true;
              // this.isKaiGuan = false
            }
            if (that.tags_current_page == 1) {
              that.mytagsArr = res.data.data.book_tags;
            } else {
              that.mytagsArr = that.mytagsArr.concat(res.data.data.book_tags);
            }
            // that.book_info = res.data.data.book_info
          }
          // console.log(that.mytagsArr.length)
          if (that.mytagsArr.length == 0) {
            that.istagsArr = false;
          } else {
            that.istagsArr = true;
          }
        }
      });
    },
    //页面跳转
    pushup() {
      var c = parseInt(this.page);
      if (c > this.imgArr.length) {
        c = this.imgArr.length - 1;
      } else {
        c = c - 1;
      }
      var b = [];
      var lis = $("div#index").find("div.imgbox");
      $.each(lis, function(index, item) {
        var mTop = item.offsetTop;
        b.push(mTop);
      });
      // console.log(b[c]);
      window.scrollTo(100, b[c]);
    },
    // 目录跳转
    catalog(index, item) {
      // console.log(index);
      // console.log(item);
      // console.log(this.booknoArr[index]);
      this.subsectionid = index;
      this.page = this.booknoArr[index];
      this.pushup();
    },
    // 添加书签
    addmark(num, item, index) {
      var that = this;
      this.ispushmark = true;
      // console.log(this.ispushmark);
      var params = {
        user_id: that.userid,
        volume_id: that.volumeid,
        img_id: item.id,
        type: num
      };
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      that.$axios.post("mark", params).then(function(res) {
        // console.log(res.data);
        that.ispushmark = false;
        if (num == 2) {
          // console.log(that.ispushmark);
          that.imgArr[index].be_marked = true;
          that.loadingmymark();
          that.imgArr[index].mark_id = res.data.data.mark_id;
          // console.log(that.imgArr)
        }
      });
    },
    // 删除书签
    removemark(item, index) {
      var that = this;
      that.ispushmark = true;
      // console.log(this.ispushmark);
      var params = {
        user_id: that.userid,
        img_id: item.id,
        mark_id: item.mark_id
      };
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      that.$axios
        .delete("mark/" + item.mark_id, { params })
        .then(function(res) {
          // console.log(res.data);
          if (res.data.status_code == 200) {
            that.ispushmark = false;
            // console.log(that.ispushmark);
            that.imgArr[index].be_marked = false;
            that.loadingmymark();
          }
        });
    },
    // 继续阅读跳转
    historyup() {
      var that = this;
      setTimeout(function() {
        that.dialogVisible = false;
        // 跳转动画
        var c = parseInt(that.historypage);
        if (c > that.imgArr.length) {
          c = that.imgArr.length - 1;
        } else {
          c = c - 1;
        }
        var b = [];
        var lis = $("div#index").find("div.imgbox");
        $.each(lis, function(index, item) {
          var mTop = item.offsetTop;
          b.push(mTop);
        });
        // 20页的高度
        var top = b[19];
        var topa = b[c];
        var start = 0;
        var ismall = false;
        if (c > 20) {
          // top = b[20]
          ismall = true;
        } else {
          top = b[c];
        }
        var timer = setInterval(function() {
          start += 100;

          if (start >= top) {
            start = top;
            if (ismall) {
              window.scrollTo(100, topa);
            } else {
              window.scrollTo(100, start);
            }
            clearInterval(timer);
          } else {
            window.scrollTo(100, start);
          }
        }, 5);
      }, 200);
    },
    OSnow() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      // if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
      // 	//your code
      // 	alert("这是windows32位系统");
      // }
      // if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
      // 	//your code
      // 	alert("这是windows64位系统");
      // }
      if (isMac) {
        //your code
        // alert("这是mac系统");
        this.isIos = true;
      }
    },
    loadpagetags(index, num) {
      var that = this;
      var img_id = this.imgArr[index].id;
      var params = {
        type: "img",
        user_id: this.userid,
        page: this.pagetagsArr[index].current_page,
        page_size: 10,
        img_id: img_id
      };
      // public:true
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      this.$axios.get("tags", { params }).then(function(res) {
        // console.log(res)
        if (res.data.status_code == 200) {
          that.pagetagsArr[index].current_page = res.data.data.current_page;
          that.pagetagsArr[index].total_pages = res.data.data.total_pages;
          if (that.pagetagsArr[index].current_page == 1) {
            that.pagetagsArr[index].tagsarr = res.data.data.book_tags;
          } else {
            that.pagetagsArr[index].tagsarr = that.pagetagsArr[
              index
            ].tagsarr.concat(res.data.data.book_tags);
          }
          setTimeout(function() {
            // that.settagmore(index, 2);
          }, 200);
        }
      });
    },
    settagmore(index, num) {
      var bheight = $(".page_tag")[index].offsetHeight;
      var cheight = $(".inpagetag")[index].offsetHeight;

      if (bheight <= cheight && cheight != 0) {
        this.tagmoreArr[index] = true;
      } else {
        this.tagmoreArr[index] = false;
      }
    },
    pagetagmore(url, item, index) {
      this.istagmore = true;
      this.tagsmoreArr = {
        url: url,
        tags: item.tagsarr
      };
      $(".pagetagimg").css({
        height: this.tagimgheigth + "px"
      });
    },
    // 发表心得
    addComments() {
      //          console.log(this.comment)
      if (this.comment && this.comment !== "") {
        let that = this;
        let datas = {
          user_id: that.$store.state.user_id,
          content: that.comment,
          book_id:that.$route.query.book_id
        };
        var sign = addstamp(datas)
        delete datas.token
        datas['sign'] = sign
        // console.log(datas)
        that
          .$axios({
            method: "post",
            url: "comment/" + that.$route.query.book_id,
            data: datas,
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            // console.log(res)
            if (res.data.status_code == 200) {
              that.comment = "";
              that.comments_current_page = 1;
              that.is_all = false;
              that.getComments();
            }else {
              alert("请先登录!");
              return false;
            }
          })
          .catch(function(err) {
            // console.log(err);
            alert("请先登录");
            return false;
          });
      }
    },
    // 获取评论列表
    getComments() {
      let that = this;
      that.isLoading = true;
      let datas = {
        page: that.comments_current_page,
        page_size: that.comments_page_size
      };
      // console.log(datas)
      that.$axios
        .get("comments/" + that.$route.query.book_id, {
          params: datas
        })
        .then(res => {
          console.log(res)
          if (res.data.status_code == 200) {
            // that.comments_current_page = res.data.data.current_page
            that.isLoading = false;
            that.comments_total_pages = res.data.data.total_pages;
            if (that.comments_current_page == that.comments_total_pages) {
              that.is_all = true;
            }
            if (that.comments_current_page === 1) {
              that.comments = res.data.data.comments;
            } else {
              that.comments = that.comments.concat(res.data.data.comments);
            }
          } else {
            return false;
          }
        })
        .catch(function(err) {
          // console.log(err);
          return false;
        });
    },
    LoadMore() {
      if (this.comments_current_page < this.comments_total_pages) {
        this.comments_current_page += 1;
        this.getComments();
      } else {
        this.is_all == true;
      }
    },
  },
  watch: {
    page() {
      for (var i = 0; i < this.booknoArr.length; i++) {
        if (this.page == this.booknoArr[i]) {
          this.subsectionid = i;
        } else if (
          this.page >= this.booknoArr[i] &&
          this.page < this.booknoArr[i + 1]
        ) {
          this.subsectionid = i;
        }
      }
      // 自动添加书签
      var ind = this.page - 1;
      var item = this.imgArr[ind];
      if (typeof item != "undefined") {
        this.addmark(1, item, ind);
      }
      //   自动加载标注
      if (this.page < this.imgArr.length - 1 && !this.istagsshow&&this.ispicturetags) {
        this.loadpagetags(this.page + 1, 4);
      }
    },
    isshowmymarks() {
      if (this.isshowmymarks) {
        $("body").css({
          overflow: "hidden"
        });
        $("#index").css({
          overflow: "scroll"
        });
        $(".catalog").css({
          right: "37px"
        });
        $(".catalog_hide").css({
          right: "37px"
        });
        $(".iconbox").css({
          right: "37px"
        });
        $(".right_btn").css({
          right: "27px"
        });
      } else {
        $("body").removeAttr("style");
        $("#index").removeAttr("style");
        // $(".catalog").removeAttr("style");
        $(".catalog").css({
          right: "20px"
        });
        $(".catalog_hide").css({
          right: "20px"
        });
        $(".iconbox").removeAttr("style");
        $(".right_btn").removeAttr("style");
      }
    },
    isshowmytags() {
      if (this.isshowmytags) {
        $("body").css({
          overflow: "hidden"
        });
        $("#index").css({
          overflow: "scroll"
        });
        $(".catalog").css({
          right: "37px"
        });
        $(".catalog_hide").css({
          right: "37px"
        });
        $(".iconbox").css({
          right: "37px"
        });
        $(".right_btn").css({
          right: "27px"
        });
      } else {
        // $("body").css({
        //   overflow: "auto"
        // });
        // $('#index').css({
        //   overflow: "inherit"
        // })
        //  $('.catalog').css({
        //   right: "20px"
        // })
        // $('.iconbox').css({
        //   right: "20px"
        // })
        // $('.right_btn').css({
        //   right: "10px"
        // })
        $("body").removeAttr("style");
        $("#index").removeAttr("style");
        // $(".catalog").removeAttr("style");
        $(".catalog").css({
          right: "20px"
        });
        $(".catalog_hide").css({
          right: "20px"
        });
        $(".iconbox").removeAttr("style");
        $(".right_btn").removeAttr("style");
      }
    },
    loadingbox() {
      if (this.loadingbox) {
        $("body").css({
          overflow: "hidden"
        });
        $("#index").css({
          overflow: "scroll"
        });
        $(".catalog").css({
          right: "37px"
        });
        $(".catalog_hide").css({
          right: "37px"
        });
        $(".iconbox").css({
          right: "37px"
        });
        $(".right_btn").css({
          right: "27px"
        });
      } else {
        // $("body").css({
        //   overflow: "auto"
        // });
        // $('#index').css({
        //   overflow: "inherit"
        // })
        //  $('.catalog').css({
        //   right: "20px"
        // })
        // $('.iconbox').css({
        //   right: "20px"
        // })
        // $('.right_btn').css({
        //   right: "10px"
        // })
        $("body").removeAttr("style");
        $("#index").removeAttr("style");
        // $(".catalog").removeAttr("style");
        $(".catalog").css({
          right: "20px"
        });
        $(".catalog_hide").css({
          right: "20px"
        });
        $(".iconbox").removeAttr("style");
        $(".right_btn").removeAttr("style");
      }
    },
    istagmore() {
      if (this.istagmore) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $("body").removeAttr("style");
      }
    },
    istagsshow() {
      if (this.istagsshow) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $("body").removeAttr("style");
      }
    },
    directArr() {
      // if(this.directArr.length = this.imgArr.length){
      //   var ofh = document.body.offsetHeight
      //   this.imgloading(ofh)
      // }
    }
  }
};
</script>
<style scoped lang="scss" type="text/css">
#index {
  width: 100%;
  // width:1903px;
  /*height: 100%;*/
  background: #333;
}
.bodyhide {
  overflow: hidden;
}

.hidden {
  display: none !important;
}

img[lazy="loading"] {
  /*zoom:0.5;*/
  width: 48px;
  height: 48px !important;
  box-sizing: border-box;
  /*border: 1px solid red;*/
}
// #kss{
// 	width: 100% !important;
// }
.bookname {
  width: 480px;
  /*text-align: center;*/
  /*background: #666;*/
  font-size: 20px;
  /*border: 1px solid red;*/
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 99;
  color: #eaeaea;
  span {
    font-size: 16px;
  }
}

.bsmall {
  width: 90px;
  height: 35px;
  /*border: 1px solid red;*/
  position: fixed;
  bottom: 20px;
  left: 235px;
  z-index: 99;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    /*border: 1px solid red;*/
    cursor: pointer;
  }
}

.imgbox {
  width: 100%;
  height: 100%;
  min-height: 100%;
  color: #fff;
  background: #333;
  // position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  /*border: 1px solid red;*/
  .imgli {
    // width: 100%;
    // height: 100%;
    // margin: 0 auto;
    cursor: pointer;
    // box-shadow: 0px 30px 50px #333;
    display: inline-block;
    position: relative;
    transition: all 1s;
    .img2 {
      width: 100%;
      height: 100%;
    }
    .bookmark {
      width: 14px;
      height: 72px;
      overflow: hidden;
      position: absolute;
      top: -1px;
      right: -14px;
      transition: all 0.5s;
      button {
        width: 51px;
        height: 72px;
        float: right;
        border: none;
        cursor: pointer;
        outline: none;
      }
      .baddmark {
        background: url(../../assets/picture/bookmarks_icon_nor@2x.png)
          no-repeat center center;
        background-size: cover;
      }
      .bdeletemark {
        background: url(../../assets/picture/bookmarks_icon_pre@2x.png)
          no-repeat center center;
        background-size: cover;
      }
    }
    .marktitle {
      opacity: 0;
      width: 64px;
      height: 26px;
      background: url(../../assets/picture/online@2x.png);
      background-size: cover;
      position: absolute;
      right: -71px;
      top: 22px;
      z-index: 9999;
      transition: all 0.5s;
      p {
        color: #333;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        text-indent: 6px;
      }
    }
    &:hover {
      .bookmark {
        width: 51px;
        right: -51px;
      }
      .marktitle {
        opacity: 1;
        right: -108px;
      }
    }
  }
}
.page_tag {
  display: inline-block;
  width: 356px;
  height: 100%;
  border: 1px solid #626262;
  margin-left: 80px;
  overflow: hidden;
  box-sizing: border-box;
  padding-bottom: 60px;
  position: relative;
  .inpagetag {
    width: 100%;
  }
  .pt_li {
    width: 100%;
    // display: none;
    box-sizing: border-box;
    padding: 9px 20px 20px 18px;
    //   border: 1px solid red;
    .pt_disc {
      width: 6px;
      height: 6px;
      vertical-align: top;
      display: inline-block;
      background: #905d3e;
      border-radius: 50%;
    }
    .ptli_content {
      width: 295px;
      // border: 1px solid red;
      display: inline-block;
      margin-left: 8px;
      .ptli_img {
        width: 60px;
        height: 60px;
        cursor: pointer;
        display: inline-block;
        border-radius: 5px;
        background-size: cover;
        vertical-align: top;
        overflow: hidden;
        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          display: block;
        }
      }
      .ptli_text {
        display: inline-block;
        width: 220px;
        // border: 1px solid red;
        color: #bbb;
        margin-left: 8px;
      }
      .ptli_user {
        width: 100%;
        height: 18px;
        line-height: 18px;
        margin-top: 10px;
        // border:1px solid red;
        color: #626262;
        img {
          width: 18px;
          height: 18px;
          vertical-align: bottom;
        }
        span {
          float: right;
        }
      }
    }
  }
  .pagetag_morebox {
    width: 100%;
    height: 60px;
    padding-top: 12px;
    position: absolute;
    bottom: 0px;
    background: #333;
  }
  .pagetag_more {
    width: 100px;
    height: 38px;
    margin: 0 auto;
    border: 1px solid #626262;
    border-radius: 4px;
    color: #626262;
    left: calc(50% - 50px);
    text-align: center;
    line-height: 38px;
    cursor: pointer;
  }
}

.page_tag2 {
  border: 1px solid transparent;
}
.left_btn,
.right_btn {
  width: 50px;
  height: 60px;
  cursor: pointer;
  padding: 10px 2px;
  background: rgba(112, 112, 112, 0.2);
  border-radius: 5px;
}

.left_btn {
  position: fixed;
  left: 10px;
  top: calc(50% - 30px);
  z-index: 99;
}

.right_btn {
  position: fixed;
  right: 10px;
  top: calc(50% - 30px);
  z-index: 99;
}

.page {
  padding: 0px 10px;
  height: 35px;
  line-height: 35px;
  position: fixed;
  bottom: 20px;
  left: 50px;
  background: #444;
  color: #eee;
  z-index: 99;
  font-size: 14px;
  text-align: center;
  .page_now {
    width: 40px;
    color: #fafafa;
    background: #666;
    text-align: right;
    font-size: 16px;
    border: none;
  }
  .page_count {
    color: #eee;
  }
}
.catalog {
  width: 315px;
  height: calc(100% - 120px);
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 999;
  background-color: #444;
  background-image: url(../../assets/picture/background@2x.png);
  background-size: 100% 100%;
  .cat_title {
    text-align: center;
    /*border: 1px solid red;*/
    font-size: 20px;
    font-family: HiraginoSansGB-W6;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: 74px;
  }
  .cat_close {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    background: url(../../assets/picture/bounced_esc_nor@2x.png) center center;
    cursor: pointer;
    background-size: 100% 100%;
    transition: 0.3s;
    &:hover {
      background: url(../../assets/picture/bounced_esc_pre@2x.png) center center;
      background-size: 100% 100%;
    }
  }

  .cat_ul {
    width: 100%;
    height: calc(100% - 74px);
    overflow-y: scroll;
    overflow-x: hidden;
    .cat_li {
      height: 40px;
      width: 100%;
      cursor: pointer;
      /*border: 1px solid red;*/
      display: flex;
      .cat_dot {
        width: 9px;
        height: 9px;
        margin-left: 19px;
        background: #737373;
        border-radius: 10px;
        margin-top: 15px;
        /*border: 1px solid red;*/
      }
      .cat_p {
        margin-left: 25px;
        line-height: 40px;
        color: #737373;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: normal;
        overflow: hidden;
        span {
          color: #777;
          margin: 0px 10px;
          font-weight: 300;
        }
      }
      &:hover {
        .cat_dot {
          background: #fff;
        }
        .cat_p {
          color: #fff;
          span {
            color: #f0f0f0;
          }
        }
      }
    }
    .cat_active {
      .cat_dot {
        background: #fff;
      }
      .cat_p {
        color: #fff;
        span {
          color: #f0f0f0;
        }
      }
    }
  }
  .cat_ul::-webkit-scrollbar {
    display: none;
  }
}
.commentbox{
  display: flex;
  width: fit-content;
  margin: 0 auto;
  margin-top: 30px;
  .comments_box {
    width: 657px;
    // margin: 0 auto;
    // margin-right: 436px;
    .comments_title {
      width: fit-content;
      font-size: 18px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #fff;
      // margin-left: 60px;
      margin-bottom: 20px;
      position: relative;
      z-index: 2;
      span {
        width: 100%;
        height: 6px;
        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 0;
        z-index: -1;
        background: #e6522b;
      }
    }
    .comment_confirm {
      width: 113px;
      height: 44px;
      background: linear-gradient(
        -55deg,
        rgba(255, 124, 90, 1),
        rgba(230, 82, 43, 1)
      );
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Light, sans-serif;
      font-weight: 300;
      color: #fff;
      margin-top: 10px;
      outline: none;
      border: none;
      float: right;
      cursor: pointer;
    }
    .comments {
      margin-top: 92px;
      padding-top: 40px;
      border-top: 1px solid #535353;
      .title {
        background: url("../../assets/public/ancientBooks/comment_icon@2x.png")
          no-repeat left center;
        background-size: 22px;
        padding-left: 30px;
        color: #fff;
        font-family: PingFangSC-Light, sans-serif;
        font-weight: 300;
        margin-bottom: 22px;
      }
      .comment {
        border-bottom: 1px solid #535353;
        padding-bottom: 30px;
        margin-bottom: 30px;
        margin-right: 34px;
        .comment_title {
          line-height: 1;
          text-align: middle;
        }
        .user {
          font-size: 18px;
          color: #fff;
          font-family: PingFangSC-Regular, sans-serif;
          font-weight: 400;
          margin-right: 15px;
        }
        .date {
          font-size: 16px;
          color: #999;
          font-family: PingFangSC-Light, sans-serif;
          font-weight: 300;
        }
        .comment_content {
          color: #666;
          font-size: 16px;
          line-height: 28px;
          margin-top: 8px;
          font-family: PingFangSC-Light, sans-serif;
          font-weight: 300;
        }
        pre {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }
    }
  }
  .commentnot{
    width: 356px;
    margin-left: 80px;
  }
}
.catalog_hide {
  width: 75px;
  height: 29px;
  line-height: 29px;
  border-radius: 29px;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 999;
  cursor: pointer;
  text-align: center;
  color: #000;
  background: #fff;
  font-family: HiraginoSansGB-W3;
  font-weight: normal;
}
.screen {
  // border: 1px solid red;
  width: 75px;
  height: 29px;
  line-height: 29px;
  border-radius: 29px;
  position: fixed;
  right: 20px;
  top: 80px;
  z-index: 99;
  cursor: pointer;
  text-align: center;
  color: #000;
  background: #fff;
  font-family: HiraginoSansGB-W3;
  font-weight: normal;
}
.tagsbox {
  width: 630px;
  height: 420px;
  position: fixed;
  left: calc(50% - 315px);
  top: calc(50% - 210px);
  z-index: 999;
  background: #fff;
  border-radius: 6px;
  // border: 1px solid red;
  box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.3);
  .closetagbox {
    cursor: pointer;
    // border: 1px solid red;
    width: 30px;
    height: 30px;
    position: absolute;
    top: -15px;
    right: -15px;
    background: url(../../assets/picture/bounced_esc_nor@2x.png) no-repeat
      center center;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/bounced_esc_pre@2x.png) no-repeat
        center center;
      background-size: 100% 100%;
    }
  }
  .tagsimgshow {
    width: 93px;
    height: 93px;
    border: 5px solid #dcdcdc;
    display: block;
    margin: 0 auto;
    margin-top: 37px;
    margin-bottom: 30px;
    overflow: hidden;
    // border: 1px solid red;
    position: relative;
  }
  .resetscreen {
    width: 20px;
    height: 20px;
    position: absolute;
    z-index: 999;
    top: 27px;
    right: 253px;
    background: url(../../assets/picture/esc_icon@2x.png);
    background-size: 100% 100%;
    cursor: pointer;
    &:hover {
      background: url(../../assets/picture/esc_icon_hover@2x.png);
      background-size: 100% 100%;
    }
  }
  .addscreen {
    width: 102px;
    height: 102px;
    cursor: pointer;
    // border: 5px solid #DCDCDC;
    background-color: #dcdcdc;
    background-image: url(../../assets/picture/add_icon@2x.png);
    background-size: 80% 80%;
    background-repeat: no-repeat;
    background-position: center center;
    display: block;
    margin: 0 auto;
    margin-top: 37px;
    margin-bottom: 30px;
  }

  .tagsarea {
    width: 550px;
    height: 160px;
    line-height: 24px;
    padding: 18px 20px;
    font-size: 16px;
    box-sizing: border-box;
    resize: none;
    display: block;
    margin: 0 auto;
    color: #333;
    // letter-spacing:1px;
    border-radius: 6px;
    border: 1px solid #dcdcdc;
  }
  .tag_bottom {
    width: 100%;
    height: 38px;
    line-height: 38px;
    margin-top: 30px;
    // border: 1px solid red;
    cursor: pointer;
    .share_community,
    .open_community {
      display: inline-block;
      line-height: 38px;
      color: #ad896b;
      margin-left: 48px;
      // border: 1px solid red;
      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .open_community{
      margin-left: 30px;
    }
    .tagssubmit {
      width: 143px;
      height: 38px;
      font-family: AlibabaPuHuiTiR;
      cursor: pointer;
      background: linear-gradient(
        45deg,
        rgba(255, 124, 90, 1),
        rgba(230, 82, 43, 1)
      );
      border-radius: 6px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      font-size: 20px;
      position: absolute;
      // bottom: 20px;
      right: 40px;
      border: none;
    }
  }
}

.iconbox {
  width: 190px;
  z-index: 999;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: space-between;
  li {
    color: #fff;
    font-size: 14px;
    font-family: AlibabaPuHuiTiR;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    img {
      width: 34px;
      height: 34px;
    }
  }
}

.prohibit {
  cursor: not-allowed;
}
// dialog
.dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  .dialog_center {
    width: 400px;
    height: 210px;
    border-radius: 6px;
    background: #fff;
    position: absolute;
    top: calc(50% - 105px);
    left: calc(50% - 200px);
    // box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.3);
    .dialogtitle {
      font-size: 24px;
      color: #333;
      margin-top: 50px;
      text-align: center;
      font-weight: bold;
    }
    .dialogconfirm {
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      p {
        line-height: 40px;
        text-align: center;
        border-radius: 6px;
        font-size: 20px;
        cursor: pointer;
        font-family: AlibabaPuHuiTiR;
      }
      .dialogfalse {
        width: 143px;
        height: 38px;
        border: 1px solid rgba(220, 220, 220, 1);
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .dialogtrue {
        width: 145px;
        height: 40px;
        background: linear-gradient(
          45deg,
          rgba(255, 124, 90, 1),
          rgba(230, 82, 43, 1)
        );
        color: #fff;
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}

// .mytags{
// 	width: 100%;
// 	height: 100%;
// 	position: fixed;
// 	z-index: 999;
// 	overflow: scroll;
// 	top: 0;
// 	left: 0;
// 	border: 1px solid red;
// }
.mytags,
.mymarks {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  // border: 1px solid red;
  background: rgba(0, 0, 0, 0.72);
  z-index: 999;
  overflow-y: scroll;
  overflow-x: hidden;
  .closebox {
    cursor: pointer;
    width: 38px;
    height: 38px;
    position: fixed;
    top: 85px;
    right: 300px;
    z-index: 996;
    background: url(../../assets/picture/mark_icon_nor@2x.png) no-repeat;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/mark_icon_pre@2x.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .mymarks_center,
  .mytags_center {
    width: 1200px;
    margin: 0 auto;
    // overflow: scroll;
    height: calc(100% - 100px);
    margin-top: 100px;
    position: relative;
    .notmarks {
      width: 300px;
      height: 260px;
      position: absolute;
      top: calc(50% - 180px);
      left: calc(50% - 150px);
      // border: 1px solid red;
      img {
        width: 300px;
        height: 220px;
      }
      p {
        text-align: center;
        margin-top: 20px;
        color: #a5a5a5;
      }
    }
    .no_more {
      color: #a5a5a5;
    }
  }
}
.img_open {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  // top: calc(50% - 300px);
  // left: calc(50% - 500px);
  /* border: 1px solid red; */
  background: #333;
  border-radius: 6px;
  .openimg_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
    // margin-top: 50px;
  }
  .closeimg {
    cursor: pointer;
    // border: 1px solid red;
    width: 38px;
    height: 38px;
    position: absolute;
    top: 85px;
    right: 300px;
    z-index: 999;
    background: url(../../assets/picture/mark_icon_nor@2x.png) no-repeat;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/mark_icon_pre@2x.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.tags_more {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  // border: 1px solid red;
  background: rgba(0, 0, 0, 1);
  z-index: 999;
  .tags_right {
    // overflow: scroll;
    overflow-y: scroll;
    overflow-x: hidden;
    // overflow: hidden;
    padding-bottom: 0px;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }
  .closeimg {
    cursor: pointer;
    // border: 1px solid red;
    width: 38px;
    height: 38px;
    position: absolute;
    top: 34px;
    right: 314px;
    z-index: 999;
    background: url(../../assets/picture/mark_icon_nor@2x.png) no-repeat;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/mark_icon_pre@2x.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.time_line {
  // padding: 2em 0;
  position: relative;
  // margin-top:95px;
  margin-bottom: 50px;
  padding-top: 60px;
  // overflow: scroll;
  overflow-y: auto;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    height: 100%;
    width: 2px;
    background: #dcdcdc;
    opacity: 0.7;
    margin-left: -1px;
  }
  .list {
    width: 610px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 98px;
    // margin-top:50px;
    &:last-child {
      margin-bottom: 35px;
    }
    &::before {
      display: block;
      content: "";
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #e5e5e5;
      position: absolute;
    }
    &::after {
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #d55d3a;
      position: absolute;
    }
    .img_circle {
      display: inline-block;
      width: 86px;
      height: 86px;
      border: 7px solid #eeeeee;
      margin: 0px 20px;
      border-radius: 50%;
      overflow: hidden;
      vertical-align: top;
      cursor: pointer;
      img {
        margin-left: -40px;
        margin-top: -30px;
      }
    }
    .tags_circle {
      display: inline-block;
      width: 86px;
      height: 86px;
      margin: 0px 20px;
      border: 7px solid #eeeeee;
      position: relative;
      // border-radius: 50%;
      overflow: hidden;
      vertical-align: top;
      cursor: pointer;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      span {
        display: none;
        // display: block;
        width: 100%;
        height: 100%;
        line-height: 86px;
        text-align: center;
        color: #fff;
        background: rgba(47, 81, 92, 0.7);
        position: absolute;
        top: 0;
        left: 0;
        transition: 1s;
      }
      &:hover span {
        display: block;
      }
    }
    .tags_text {
      vertical-align: top;
      // margin-left:30px;
      margin-top: -10px;
      margin-right: 30px;
      position: relative;
      width: 410px;
      color: #fff;
      .tags_page,
      .content {
        display: block;
      }
      .tags_page {
        color: #d55d3a;
        font-size: 30px;
        cursor: pointer;
        font-weight: 500;
        font-family: DINAlternate-Bold;
        margin-right: 5px;
      }
      .centent {
        width: 410px;
        display: block;
        font-size: 16px;
        font-family: AlibabaPuHuiTiL;
        color: #fff;
        cursor: pointer;
      }
    }
    .text {
      vertical-align: top;
      // margin-left:20px;
      margin-top: -22px;
      position: relative;
      .mark_page,
      .time {
        display: block;
      }
      .mark_page {
        font-size: 20px;
        cursor: pointer;
        color: #fff;
        font-family: AlibabaPuHuiTiB;
        font-weight: bold;
        .font_74 {
          color: #d55d3a;
          font-weight: 500;
          font-size: 56px;
          font-family: DINAlternate-Bold;
          margin-right: 5px;
        }
      }
      .time {
        display: block;
        font-size: 30px;
        font-family: DINAlternate-Bold;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .right {
    float: right;
    padding-left: 16px;
    &::before {
      top: 40px;
      left: 2px;
    }
    &::after {
      top: 43px;
      left: 5px;
    }
    .img_circle,
    .text,
    .tags_circle,
    .tags_text {
      float: left;
    }
  }
  .left {
    padding-right: 16px;
    float: left;
    text-align: right;
    &::before {
      top: 40px;
      right: 2px;
    }
    &::after {
      top: 43px;
      right: 5px;
    }
    .img_circle,
    .text,
    .tags_circle,
    .tags_text {
      float: right;
    }
  }

  &::after {
    content: "";
    display: table;
    clear: both;
  }
}
</style>
<style>
/* #index .comments_box .el-textarea el-textarea{
  
} */
.el-loading-spinner .el-loading-text {
  color: #fff !important;
  letter-spacing: 1px;
  font-size: 13px;
}
.el-loading-spinner i {
  color: #fff !important;
}
.viewer-open .catalog,
.viewer-open .catalog_hide,
.viewer-open .iconbox {
  right: 37px !important;
}
.viewer-open .right_btn {
  right: 27px !important;
}
.viewer-open #index {
  overflow: hidden !important;
}
.loadingBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.7);
}
.loadingBox p {
  color: #fff;
  width: 100%;
  text-align: center;
  position: relative;
  font-size: 18px;
  top: calc(50% - 34px);
}
.loadEffect {
  width: 100px;
  height: 100px;
  position: relative;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
}
.loadEffect span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ead3b6;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
}
@-webkit-keyframes load {
  0% {
    -webkit-transform: scale(1.2);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.3);
    opacity: 0.5;
  }
}
.loadEffect span:nth-child(1) {
  left: 0;
  top: 50%;
  margin-top: -10px;
  -webkit-animation-delay: 0.13s;
}
.loadEffect span:nth-child(2) {
  left: 14px;
  top: 14px;
  -webkit-animation-delay: 0.26s;
}
.loadEffect span:nth-child(3) {
  left: 50%;
  top: 0;
  margin-left: -10px;
  -webkit-animation-delay: 0.39s;
}
.loadEffect span:nth-child(4) {
  top: 14px;
  right: 14px;
  -webkit-animation-delay: 0.52s;
}
.loadEffect span:nth-child(5) {
  right: 0;
  top: 50%;
  margin-top: -10px;
  -webkit-animation-delay: 0.65s;
}
.loadEffect span:nth-child(6) {
  right: 14px;
  bottom: 14px;
  -webkit-animation-delay: 0.78s;
}
.loadEffect span:nth-child(7) {
  bottom: 0;
  left: 50%;
  margin-left: -10px;
  -webkit-animation-delay: 0.91s;
}
.loadEffect span:nth-child(8) {
  bottom: 14px;
  left: 14px;
  -webkit-animation-delay: 1.04s;
}
</style>



// WEBPACK FOOTER //
// src/components/page/viewpicture2.vue